import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { BaseDataService } from './base.data.service';
import { IOrganisationTag } from '../interfaces/organisation-tag';
import { ITaggingAudit } from '../interfaces/tagging-audit';

@Injectable({ providedIn: 'root' })
export class OrganisationTagsService extends BaseDataService {
  private url = '/api/organisationtags';
  private entityTitle = 'Organisation Tags';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  public getCustomerOrganisationData(id: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.url}/getcustomerorganisationdata/${id}`);
  }

  public getAllCustomerOrganisationData(): Observable<any[]> {
    return this.http.get<any[]>(`${this.url}/getallcustomerorganisationdata`);
  }

  public getSuppliersOrganisationData(id: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.url}/getsupplierorganisationdata/${id}`);
  }

  public getAudit(id: number): Promise<ITaggingAudit[]> {
    return this.http.get<ITaggingAudit[]>(`/api/organisation/${id}/taggingAudit`).toPromise();
  }

  public saveCustomerTags(customerStructureTaggingDataDTO): Promise<boolean> {
    return this.http
      .post<boolean>(`${this.url}/savecustomertags`, customerStructureTaggingDataDTO)
      .toPromise();
  }

  public saveSupplierTags(supplierStructureTaggingDTOs): Promise<boolean> {
    return this.http
      .post<boolean>(`${this.url}/saveSupplierTags`, supplierStructureTaggingDTOs)
      .toPromise();
  }

  public removeSupplierTag(tagId): Promise<boolean> {
    return this.http.delete<any>(`${this.url}/tag/${tagId}`).toPromise<boolean>();
  }
}
